<button
  type="button"
  (click)="onClick($event)"
  [title]="tooltip"
  [attr.aria-label]="tooltip"
  data-no-row-click
  [disabled]="disabled || loading"
  class="inline-flex items-center justify-center p-1.5 rounded-lg text-stone-400 hover:text-primary hover:bg-stone-100/80 active:scale-95 transition-colors duration-150 cursor-pointer outline-none focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed"
>
  @if (loading) {
    <svg role="img" aria-hidden="true" class="animate-spin w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
    </svg>
  } @else if (!archived) {
    <!-- Icon Archive (Archiver) - Clean Outline -->
    <svg
      role="img"
      [attr.aria-label]="tooltip"
      class="w-[18px] h-[18px]"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="4" width="18" height="4" rx="1" />
      <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8" />
      <path d="M10 12h4" />
    </svg>
  } @else {
    <!-- Icon Unarchive (Désarchiver) - Clean Outline -->
    <svg
      role="img"
      [attr.aria-label]="tooltip"
      class="w-[18px] h-[18px]"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="4" width="18" height="4" rx="1" />
      <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8" />
      <path d="M12 16v-5" />
      <path d="M9.5 13.5 12 11l2.5 2.5" />
    </svg>
  }
</button>
